/* eslint-disable id-blacklist */
/* eslint-disable max-len */

import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { NetworkService } from './network.service';
import { MessagingService } from './messaging.service';
import { Observable } from 'rxjs';
import { OfflineService } from './offline.service';
import { Request } from '../model/request';

@Injectable({
  providedIn: 'root',
})
export class DataProviderService {
  private jobsPlan: any[] = [];
  private eljakimJobsPlan: any[] = [];
  private nonVisitPlan: any[] = [];
  private visitResults: any[] = [];
  private pendingRequests: Request[] = [];
  private intervalId;

  constructor(
    private offlineservice: OfflineService,
    private apiservice: RestService,
    private networkservice: NetworkService,
    private messagingservice: MessagingService
  ) {
    this.subscribeForNetworkChanges();
  }

  getUserName() {
    return this.apiservice.getUsername();
  }

  getDBUserName() {
    return this.apiservice.getDBUserName();
  }

  getJob(id: number) {
    return new Observable<any>((observer) => {
      this.jobsPlan.forEach((job) => {
        if (job.id === id) {
          observer.next(job);
        }
      });
    });
  }
  getQuestionnaire(
    visitId: number,
    parentObject: string,
    customFormId: number,
    refreshFromApi: boolean = true,
    questionnaireId: number | null = null
  ): Observable<any> {
    return new Observable<any>((observer) => {
      if (refreshFromApi) {
        if (this.networkservice.isOnline()) {
          this.getOnlineQuestionnaire(
            visitId,
            parentObject,
            customFormId,
            questionnaireId
          )
            .then((data) => {
              observer.next(data);
              observer.complete();
            })
            .catch((error) => {
              observer.error(error);
            });
        } else {
          this.getOfflineQuestionnaire(visitId, parentObject, customFormId)
            .then((data) => {
              if (data !== null) {
                observer.next(JSON.parse(data));
              } else {
                observer.next([]);
              }
              observer.complete();
            })
            .catch((error) => {
              observer.error(error);
            });
        }
      } else {
        this.getOfflineQuestionnaire(visitId, parentObject, customFormId)
          .then((data) => {
            observer.next(data);

            observer.complete();
          })
          .catch((error) => {
            observer.error(error);
          });
      }
    });
  }

  getPhotos(type: string, answerId: number): Observable<any> {
    return new Observable<any>((observer) => {
      if (this.networkservice.isOnline()) {
        this.getOnlinePhotos(type, answerId).then((data) => {
          observer.next(data);
          observer.complete();
        });
      } else {
        observer.next(0);
        observer.complete();
      }
    });
  }

  getComments(type: string, answerId: number): Observable<any> {
    return new Observable<any>((observer) => {
      if (this.networkservice.isOnline()) {
        this.getOnlineComments(type, answerId).then((data) => {
          observer.next(data);
          observer.complete();
        });
      } else {
        observer.next(0);
        observer.complete();
      }
    });
  }

  postAnswer(type: string, answerId: number, json): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.networkservice.isOnline()) {
        this.apiservice
          .saveQuestionnaireAnswers(type, answerId, json)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      } else {
        // storing pendingRequest for future send
        const request: Request =
          this.apiservice.getSaveQuestionnaireAnswersOfflineRequest(
            type,
            answerId,
            json
          );
        this.pendingRequests.push(request);
        this.storePendingRequests();
      }
    });
  }

  savePhoto(type: string, answerId: number, json): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.networkservice.isOnline()) {
        this.apiservice
          .saveQuestionnairePhoto(type, answerId, json)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      } else {
        // storing pendingRequest for future send
        const request: Request =
          this.apiservice.getSaveQuestionnairePhotoOfflineRequest(
            type,
            answerId,
            json
          );
        this.pendingRequests.push(request);
        this.storePendingRequests();
        resolve(json);
      }
    });
  }

  updatePhoto(type: string, photoId: number, json): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.networkservice.isOnline()) {
        this.apiservice
          .updateQuestionnairePhoto(type, photoId, json)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      } else {
        // storing pendingRequest for future send
        const request: Request =
          this.apiservice.getUpdateQuestionnairePhotoOfflineRequest(
            type,
            photoId,
            json
          );
        this.pendingRequests.push(request);
        this.storePendingRequests();
        resolve(json);
      }
    });
  }

  saveComment(type: string, answerId: number, json): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.networkservice.isOnline()) {
        this.apiservice
          .saveQuestionnaireComment(type, answerId, json)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      } else {
        // storing pendingRequest for future send
        const request: Request =
          this.apiservice.getSaveQuestionnaireCommentOfflineRequest(
            type,
            answerId,
            json
          );
        this.pendingRequests.push(request);
        this.storePendingRequests();
        resolve(json);
      }
    });
  }

  updateComment(type: string, commentId: number, json): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.networkservice.isOnline()) {
        this.apiservice
          .updateQuestionnaireComment(type, commentId, json)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      } else {
        // storing pendingRequest for future send
        const request: Request =
          this.apiservice.getUpdateQuestionnaireCommentOfflineRequest(
            type,
            commentId,
            json
          );
        this.pendingRequests.push(request);
        this.storePendingRequests();
        resolve(json);
      }
    });
  }

  deletePhoto(type: string, photoId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.networkservice.isOnline()) {
        this.apiservice
          .deleteQuestionnairePhoto(type, photoId)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      } else {
        // storing pendingRequest for future send
        const request: Request =
          this.apiservice.getDeleteQuestionnairePhotoOfflineRequest(
            type,
            photoId
          );
        this.pendingRequests.push(request);
        this.storePendingRequests();
      }
    });
  }

  deleteComment(type: string, commentId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.networkservice.isOnline()) {
        this.apiservice
          .deleteQuestionnaireComment(type, commentId)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => reject(error));
      } else {
        // storing pendingRequest for future send
        const request: Request =
          this.apiservice.getDeleteQuestionnaireCommentOfflineRequest(
            type,
            commentId
          );
        this.pendingRequests.push(request);
        this.storePendingRequests();
      }
    });
  }

  saveOfflineQuestionnaire(
    questionnaire: any,
    parentObject: string,
    id: number
  ) {
    this.offlineservice.store(
      this.apiservice.getUsername(),
      'questionnaire/' + parentObject + '/' + id,
      JSON.stringify(questionnaire)
    );
  }

  getPendingRequests(): Promise<Request[]> {
    return new Promise<Request[]>((resolve, reject) => {
      this.offlineservice
        .get(this.getUserName(), 'requests')
        .then((dataRaw) => {
          let data: Request[] = JSON.parse(dataRaw);
          if (data == null) {
            data = [];
          }
          this.pendingRequests = data;
          resolve(data);
        })
        .catch((error) => {
          const data: Request[] = [];
          this.pendingRequests = data;
          resolve(data);
        });
    });
  }

  storePendingRequests() {
    this.messagingservice.pendingRequestsChanged.emit(
      this.pendingRequests.length
    );
    return this.offlineservice.store(
      this.getUserName(),
      'requests',
      JSON.stringify(this.pendingRequests)
    );
  }

  wait(ms) {
    const start = new Date().getTime();
    let end = start;
    while (end < start + ms) {
      end = new Date().getTime();
    }
  }

  sendAllPendingRequests(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      this.messagingservice.pendingRequestsSending.emit(
        this.pendingRequests.length
      );
      const pending: Request[] = [];
      for (const request of this.pendingRequests) {
        if (await this.apiservice.putPendingRequest(request)) {
        } else {
          pending.push(request);
        }
      }
      this.pendingRequests = pending;
      this.messagingservice.pendingRequestsSent.emit();
      this.storePendingRequests();
      if (this.pendingRequests.length > 0) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }

  subscribeForNetworkChanges() {
    this.messagingservice.networkStatusChanged.subscribe((status: boolean) => {
      if (status) {
        this.sendAllPendingRequests();
      }
    });
  }

  clearLocalStorage() {
    this.offlineservice.clearLocalStorage();
  }

  private getOfflineQuestionnaire(
    id: number,
    parentObject: string,
    customFormId: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let questionnaire: any = [];

      this.offlineservice
        .getQuestionnaire(id, parentObject, customFormId)
        .then((data) => {
          questionnaire = JSON.parse(data);

          resolve(questionnaire);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private getOnlineQuestionnaire(
    id: number,
    parentObject: string,
    customFormId: number,
    questionnaireId: number | null = null
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let questionnaire = [];

      const visits = this.apiservice
        .getQuestionnaire(id, parentObject, customFormId, questionnaireId)
        .then((data) => {
          questionnaire = data;
        });
      Promise.resolve(visits)
        .then(() => {
          this.offlineservice.store(
            this.apiservice.getUsername(),
            'questionnaire/' + customFormId + '/' + parentObject + '/' + id,
            JSON.stringify(questionnaire)
          );
          resolve(questionnaire);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private getOnlinePhotos(type: string, answerId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let photos = [];

      const photosPromise = this.apiservice
        .getQuestionnairePhotos(type, answerId)
        .then((data) => {
          photos = data;
        });
      Promise.resolve(photosPromise)
        .then(() => {
          resolve(photos);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private getOnlineComments(type: string, answerId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let comments = [];

      const commentsPromise = this.apiservice
        .getQuestionnaireComments(type, answerId)
        .then((data) => {
          comments = data;
        });
      Promise.resolve(commentsPromise)
        .then(() => {
          resolve(comments);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
